// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"343":"itowns_potree2worker","352":"itowns_lasworker"}[chunkId] + ".umd.js";
};